import { apiSlice } from "../api/apiSlice";

export const assignmentMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentsMark: builder.query({
      query: () => `/assignmentMark`,
    }),
    getAssignmentMark: builder.query({
      query: (id) => `/assignmentMark/${id}`,
    }),
    submitAssignment: builder.mutation({
      query: ({ data }) => ({
        url: "/assignmentMark",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const assignmentMark = await queryFulfilled;

          if (assignmentMark?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignmentsMark",
                undefined,
                (draft) => {
                  // Update the relevant task in the tasks array
                  draft.push(assignmentMark?.data);

                  return draft;
                }
              )
            );
          }
        } catch {}
      },
    }),
    publishAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignmentMark/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const assignment = await queryFulfilled;

          if (assignment?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignmentsMark",
                undefined,
                (draft) => {
                  // Update the relevant task in the tasks array
                  const assignmentIndex = JSON.stringify(
                    // eslint-disable-next-line
                    draft.findIndex((assignment) => assignment.id == arg?.id)
                  );

                  Object.assign(draft[assignmentIndex], assignment?.data);

                  return draft;
                }
              )
            );
          }
        } catch {}
      },
    }),
  }),
});

export const {
  useGetAssignmentsMarkQuery,
  useGetAssignmentMarkQuery,
  useSubmitAssignmentMutation,
  usePublishAssignmentMarkMutation,
} = assignmentMarkApi;
